import { invokeRPC } from './socket.js'

export function getViewPreviewUploadToken(viewId) {
  return invokeRPC('view', 'getViewPreviewUploadToken', { id: viewId })
}

export function addViewToProject(data) {
  return invokeRPC('view', 'addViewToProject', data)
}

export function addViewsToProject(data) {
  return invokeRPC('view', 'addViewsToProject', data)
}

export function getViewsForProject(projectId) {
  return invokeRPC('view', 'getViewsForProject', { project_id: projectId })
}

export function getTableauViewFromProject(projectId) {
  return invokeRPC('view', 'getTableauViewFromProject', { project_id: projectId })
}

export function getProjectViewsForNavigation(projectId) {
  return invokeRPC('view', 'getProjectViewsForNavigation', { project_id: projectId })
}

export function getWorkbookId(projectId) {
  return invokeRPC('view', 'getWorkbookId', { project_id: projectId })
}

export function deleteView(viewId) {
  return invokeRPC('view', 'deleteView', { view_id: viewId })
}

export function getView(viewId) {
  return invokeRPC('view', 'getView', { view_id: viewId })
}
export function checkViewStatus(viewId) {
  return invokeRPC('view', 'checkViewStatus', { view_id: viewId })
}

export function updateView(viewId, name, viewDescription, published) {
  return invokeRPC('view', 'updateView', {
    view_id: viewId,
    name: name,
    view_description: viewDescription,
    published: !!published
  })
}

export function updateViewIcon(viewId, icon) {
  return invokeRPC('view', 'updateViewIcon', {
    view_id: viewId,
    icon: icon
  })
}

export function updateViewTypeTableau(viewId, name, viewDescription, published, type, typeData) {
  return invokeRPC('view', 'updateView', {
    view_id: viewId,
    name: name,
    view_description: viewDescription,
    published: !!published,
    type,
    type_data: typeData
  })
}

export function orderViews(order) {
  return invokeRPC('view', 'orderViews', { order: order })
}

export function deleteViewImage(viewId) {
  return invokeRPC('view', 'deleteViewImage', { id: viewId })
}

export function deleteViewIcon(viewId) {
  return invokeRPC('view', 'deleteViewIcon', { id: viewId })
}

export function getLatestActivity(userId) {
  return invokeRPC('project', 'getLatestActivity', { user_id: userId })
}

export function getViewDescription(view_id) {
  return invokeRPC('view', 'getViewDescription', { view_id: view_id })
}